"use client";
import { useDashboardState } from "./useDashboardState";
import TopBar from "./TopBar";
import TabNavigation from "./TabNavigation";
import ControlStrip from "./ControlStrip";
import OverviewTab from "./OverviewTab";
import IncomeTab from "./IncomeTab";
import ROITab from "./ROITab";
import BeneficiariesTab from "./BeneficiariesTab";
import AIAnalysisTab from "./AIAnalysisTab";

export default function DashboardPage() {
  const state = useDashboardState();

  return (
    <>
    <div className="bg-white p-8 min-h-screen rounded-b-2xl rounded-tr-2xl shadow-xl font-[Poppins]">
    <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
      <TopBar />
      <TabNavigation activeTab={state.activeTab} onTabChange={state.setActiveTab} />
      <ControlStrip state={state} />

      {state.loading && <div className="mb-6 rounded-xl border border-slate-200 bg-white p-5 text-sm text-slate-500">Loading ROI Booster data…</div>}
      {state.error && <div className="mb-6 rounded-xl border border-rose-200 bg-rose-50 p-5 text-sm text-rose-700">{state.error}</div>}

      {!state.loading && state.activeTab === "overview" && <OverviewTab state={state} />}
      {!state.loading && state.activeTab === "income" && <IncomeTab state={state} />}
      {!state.loading && state.activeTab === "roi" && <ROITab state={state} />}
      {!state.loading && state.activeTab === "ai-analysis" && <AIAnalysisTab state={state} />}
      {state.activeTab === "beneficiaries" && <BeneficiariesTab />}
    </div>
    </div>
    </>
  );
}
